import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import WarehouseVendorCreateForm from "./-form";
import { WarehouseVendorCrumbs } from "./-crumbs";

const searchSchema = z.object({
  warehouseId: z.number().optional(),
  vendorId: z.number().optional(),
});

export const Route = createFileRoute(
  "/_private/_warehouse-360/warehouse-vendor/create",
)({
  validateSearch: searchSchema,
  component: WarehouseVendorCreatePage,
});

function WarehouseVendorCreatePage() {
  return (
    <div>
      <title>Create Warehouse Vendor - Legrande Health Portal</title>
      <WarehouseVendorCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Link Warehouse to Vendor</CardTitle>
          <CardDescription>
            Link an warehouse item to a vendor who supplies it.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <WarehouseVendorCreateForm />
        </CardContent>
      </Card>
    </div>
  );
}
